exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.comment-list-container{display:flex;flex-direction:column;min-height:180px;margin-bottom:2rem;width:100%}.comment-list-container .comment-list__main{padding:16px 16px 16px 24px}.comment-list-container .comment-list__comments .empty-comments-label{color:#2c2c2c;font-family:Open Sans,sans-serif;font-size:12px}.comment-list-container .comment-list__comments.closed{height:0;overflow:hidden}.comment-list-container .comment-list__header{display:flex;flex-direction:row;justify-content:space-between;margin-bottom:12px}.comment-list-container .comment-list__expander{cursor:pointer}.comment-list-container .comment-list__label{font-family:Open Sans,sans-serif;font-weight:600;color:#2c2c2c;text-transform:uppercase;font-size:14px}.comment-list-container .comment-list__divider{border:1px solid #8b8b8b}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/CommentList/CommentList.scss
// module id = 1537
// module chunks = 0